import * as React from "react";

import { Point } from "./models";

export const PointCircle: React.FunctionComponent<{point: Point; label?: string | number}> = (props) => {
    const circleRadius = 20;

    return (
        <>
            <circle cx={props.point.x} cy={props.point.y} r={circleRadius} fill="#fff" fillOpacity="0.7" stroke="#000" />
            {props.label &&
            <text
                fill="#f00"
                textAnchor="middle"
                alignmentBaseline="central"
                height={circleRadius * 2}
                width={circleRadius * 2}
                x={props.point.x}
                y={props.point.y}
            >
                {props.label}
            </text>}
        </>
    );
};
